(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-related-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.related-articles');
    
    sections.forEach(section => {
      const track = section.querySelector('.related-articles__slider-track');
      const dots = section.querySelectorAll('.related-articles__dot');
      
      if (!track || dots.length === 0) return;
      
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.index);
          
          // Move the track by 100% of the window width for each page (3 cards)
          track.style.transform = `translateX(-${index * 100}%)`;
          
          // Update dot states
          dots.forEach(d => d.classList.remove('is-active'));
          dot.classList.add('is-active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-sidebar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sidebarNav = document.querySelector('.article-content-sidebar__nav');
    const sidebarList = document.querySelector('[data-sidebar-list]');
    const containerEl = document.querySelector('.article-content-sidebar__container');
    const summarySection = document.getElementById('blog-summary');
    const articleBody = document.getElementById('generated-article-liquid');

    if (!sidebarNav || !sidebarList || !summarySection || !containerEl) return;

    function slugify(text) {
      return text.toLowerCase().trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 60) || 'section';
    }

    /* Build dynamic TOC entries from <h2>s. */
    const dynamicIds = [];
    if (articleBody) {
      const headings = articleBody.querySelectorAll('h2');
      const anchorLi =
        sidebarList.querySelector('.article-content-sidebar__item--products') ||
        sidebarList.querySelector('.article-content-sidebar__item--faqs') ||
        null;

      headings.forEach((h2, idx) => {
        const text = (h2.textContent || '').trim();
        if (!text) return;

        let id = h2.id;
        if (!id) {
          let base = slugify(text);
          let candidate = base;
          let n = 1;
          while (document.getElementById(candidate)) {
            n += 1;
            candidate = base + '-' + n;
          }
          id = candidate;
          h2.id = id;
        }
        dynamicIds.push(id);

        const li = document.createElement('li');
        li.className = 'article-content-sidebar__item article-content-sidebar__item--toc';

        const a = document.createElement('a');
        a.href = '#' + id;
        a.className = 'article-content-sidebar__link';
        a.setAttribute('data-toc-link', '');

        const num = document.createElement('span');
        num.className = 'article-content-sidebar__link-num';
        num.textContent = (idx + 1).toString().padStart(2, '0');

        const label = document.createElement('span');
        label.className = 'article-content-sidebar__link-label';
        label.textContent = text;

        a.appendChild(num);
        a.appendChild(label);
        li.appendChild(a);
        sidebarList.insertBefore(li, anchorLi);
      });
    }

    const firstAnchor =
      sidebarList.querySelector('.article-content-sidebar__item--products') ||
      sidebarList.querySelector('.article-content-sidebar__item--faqs');
    if (firstAnchor && dynamicIds.length > 0) {
      firstAnchor.classList.add('article-content-sidebar__item--first-anchor');
    }

    const sectionIds = ['blog-summary', ...dynamicIds, 'products', 'faqs-section'];
    const sections = sectionIds.map(id => document.getElementById(id)).filter(el => el !== null);
    const allLinks = sidebarList.querySelectorAll('.article-content-sidebar__link');

    /* Stop element for the bottom anchor — last tracked section (FAQs by
       default; falls back to last H2 then to the summary). */
    const stopEl = sections[sections.length - 1] || summarySection;

    /* ----------------------------------------------------------------
       Three-phase lifecycle.
       ---------------------------------------------------------------- */
    let currentPhase = '';

    function applyPhase(phase, topPx) {
      if (phase === currentPhase) {
        // Re-apply inline top in case dimensions changed (e.g. lazy images
        // shifted layout). No class flip needed.
        if (typeof topPx === 'number') {
          sidebarNav.style.top = topPx + 'px';
        }
        return;
      }
      sidebarNav.classList.remove('is-anchor-top', 'is-sticky', 'is-anchor-bottom');
      if (phase === 'A') {
        sidebarNav.classList.add('is-anchor-top');
        sidebarNav.style.top = topPx + 'px';
      } else if (phase === 'B') {
        sidebarNav.classList.add('is-sticky');
        sidebarNav.style.top = '';
      } else {
        sidebarNav.classList.add('is-anchor-bottom');
        sidebarNav.style.top = topPx + 'px';
      }
      currentPhase = phase;
    }

    function update() {
      const scrollY = window.scrollY;
      const viewportH = window.innerHeight;
      const sidebarHeight = sidebarNav.offsetHeight || sidebarNav.scrollHeight || 0;
      const stickyTop = viewportH * 0.15;

      const containerDocTop = containerEl.getBoundingClientRect().top + scrollY;
      const overviewDocTop = summarySection.getBoundingClientRect().top + scrollY;
      const stopRect = stopEl.getBoundingClientRect();
      const stopDocBottom = stopRect.top + scrollY + stopEl.offsetHeight;

      const stickyEntryY = overviewDocTop - stickyTop;       // A -> B threshold
      const stickyExitY  = stopDocBottom - sidebarHeight - stickyTop; // B -> C threshold

      if (scrollY < stickyEntryY) {
        // PHASE A: anchored at overview top
        applyPhase('A', overviewDocTop - containerDocTop);
      } else if (scrollY < stickyExitY) {
        // PHASE B: sticky in viewport
        applyPhase('B');
      } else {
        // PHASE C: anchored at FAQ bottom (sidebar bottom = stopDocBottom)
        applyPhase('C', stopDocBottom - sidebarHeight - containerDocTop);
      }
    }

    /* Hash-based active highlight (no scroll-spy, no flicker). */
    function updateActiveFromHash() {
      const hash = window.location.hash;
      allLinks.forEach(link => {
        link.classList.remove('is-active');
        if (hash && link.getAttribute('href') === hash) {
          link.classList.add('is-active');
        }
      });
    }
    allLinks.forEach(link => {
      link.addEventListener('click', () => {
        setTimeout(updateActiveFromHash, 0);
      });
    });
    window.addEventListener('hashchange', updateActiveFromHash);
    updateActiveFromHash();

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-hero"] && !Shopify.designMode) return;
  try {
    
/* Hero video autoplay bootstrap.
   Some browsers stall muted-autoplay on initial load (esp. when the page was
   not user-initiated, or when the tab was briefly backgrounded during page
   load). Force-call .play() on DOM-ready, on visibility change, and on first
   click to recover. Errors are swallowed because muted .play() is allowed. */
(function () {
  if (window.__wkHeroVideoBoot) return;
  window.__wkHeroVideoBoot = true;
  function boot() {
    var v = document.querySelector('.wk-hero__video');
    if (!v) return;
    function tryPlay() {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
    tryPlay();
    /* Re-play on any pause. Some browsers / extensions briefly throttle
       muted-autoplay videos shortly after page load — re-trigger on pause
       to keep the hero loop continuous. Skip if video has actually ended
       (it's set to loop=true so this shouldn't fire, but defensive). */
    v.addEventListener('pause', function () {
      if (!v.ended && !document.hidden) {
        setTimeout(tryPlay, 50);
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlay();
    });
    document.addEventListener('click', tryPlay, { once: true, passive: true });
    document.addEventListener('touchstart', tryPlay, { once: true, passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-inside-flatlay"] && !Shopify.designMode) return;
  try {
    
/* Click a pin → smooth-scroll to the matching legend item and briefly
   highlight it. No-op if anchors don't exist. */
(function () {
  if (window.__wkFlatlayInit) return;
  window.__wkFlatlayInit = true;
  function init() {
    var pins = document.querySelectorAll('.wk-flatlay__pin[data-callout-target]');
    pins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        var id = pin.getAttribute('data-callout-target');
        var target = document.getElementById(id);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        /* Visually pulse the target */
        target.style.transition = 'background 250ms ease';
        target.style.background = 'var(--wk-bone)';
        setTimeout(function () { target.style.background = ''; }, 1200);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-proof"] && !Shopify.designMode) return;
  try {
    
/* Athlete proof slider — INFINITE scroll.
   Strategy: at runtime, clone the original cards into a left buffer and a
   right buffer. Initial scroll lands at the start of the original set (so
   buffers are off-screen on both sides). When the user scrolls past either
   boundary, instantly teleport scrollLeft by ±N*step where N=originals.length
   and step=card width + gap. The teleport is invisible because it lands on
   an identical card (same content, same snap-point), so the user perceives
   continuous infinite scroll in either direction. */
(function () {
  if (window.__wkProofSliderInit) return;
  window.__wkProofSliderInit = true;

  function init() {
    var slider = document.querySelector('[data-wk-proof-slider]');
    if (!slider) return;
    var track = slider.querySelector('[data-wk-proof-track]');
    var prev  = slider.querySelector('[data-wk-proof-prev]');
    var next  = slider.querySelector('[data-wk-proof-next]');
    if (!track) return;

    var originals = Array.from(track.children);
    if (originals.length === 0) return;

    function makeClone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.dataset.wkClone = '1';
      // Prevent screen readers from reading duplicates as separate items
      c.setAttribute('role', 'presentation');
      return c;
    }

    // Append right buffer
    originals.forEach(function (el) { track.appendChild(makeClone(el)); });
    // Prepend left buffer (insert in original order at the front)
    for (var i = originals.length - 1; i >= 0; i--) {
      track.insertBefore(makeClone(originals[i]), track.firstChild);
    }

    function step() {
      var first = track.firstElementChild;
      if (!first) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.gap || styles.columnGap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function originStart() {
      return originals.length * step();
    }

    function teleport(pos) {
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = pos;
      /* Force reflow before restoring smooth scroll so the teleport is
         applied instantly (not animated). */
      void track.offsetWidth;
      track.style.scrollBehavior = prevBehavior;
    }

    /* Land on the start of the original set so both buffers are off-screen. */
    teleport(originStart());

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var s = step();
        var n = originals.length;
        var sl = track.scrollLeft;
        var origStartPos = n * s;
        var origEndPos   = 2 * n * s;
        /* Teleport when the user crosses 50% of a card-step into a buffer.
           Lands on the matching card in the original set, so the switch is
           imperceptible (same image, same scroll-snap point). */
        if (sl < origStartPos - (s * 0.5)) {
          teleport(sl + n * s);
        } else if (sl > origEndPos - (s * 0.5)) {
          teleport(sl - n * s);
        }
        ticking = false;
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    /* Infinite means there's never a "first" or "last" position — leave
       both nav buttons enabled at all times. */
    if (prev) prev.disabled = false;
    if (next) next.disabled = false;

    /* Re-anchor on viewport resize (card widths reflow at breakpoints). */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { teleport(originStart()); }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();
})();
